export default function FileUpload() {
    return {
        file: null,
        updatedFiles: null,
        processing: false,
        handleUpload() {
            this.file = this.$refs.file.files[0];

            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('action', 'documents_account_upload');
            formData.append('security', themosis.upload_nonce);

            this.processing = true;
            fetch(themosis.ajaxurl, {
                method: 'POST',
                body: formData
            }).then(response => {
                return response.json();
            }).then(json => {
                this.updatedFiles = json.data.existing_files;
                if(!json.success) {
                    alert(json.data.error)
                }
                this.processing = false;
            })
        },
        handleDelete(file_id) {
            let formData = new FormData();
            formData.append('action', 'documents_account_delete');
            formData.append('security', themosis.delete_nonce);
            formData.append('file_id', file_id);

            this.processing = true;
            fetch(themosis.ajaxurl, {
                method: 'POST',
                body: formData
            }).then(response => {
                return response.json();
            }).then(json => {
                this.updatedFiles = json.data.existing_files;
                if(!json.success) {
                    alert(json.data.error)
                }
                this.processing = false;
            })
        },
        updatedFilesHandler() {
            console.log(this.updatedFiles);
            if (!Array.isArray(this.updatedFiles)) return [];
            
            return this.updatedFiles.map(file => {
                let currFile = file.document;
                currFile.date = new Date(currFile.date).toLocaleDateString();
                currFile.date = currFile.date.replace(/\//g, '.');
                return currFile;
            });
        }
    }
}
